// Shared lazy-loader for KaTeX (module + stylesheet), so the library is only
// ever fetched once — by RichText when rendering authored math, or by the
// formula insert button when previewing it — and never for content that
// doesn't use math.

let cssPromise: Promise<unknown> | null = null;

export async function loadKatex() {
  if (!cssPromise) cssPromise = import('./katexStyles');
  const [, mod] = await Promise.all([cssPromise, import('katex')]);
  return mod.default;
}
